import { render, staticRenderFns } from "./sourceInfo.vue?vue&type=template&id=b3052f48"
import script from "./sourceInfo.vue?vue&type=script&lang=js"
export * from "./sourceInfo.vue?vue&type=script&lang=js"
import style0 from "./sourceInfo.vue?vue&type=style&index=0&id=b3052f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports